/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Key_Helpful_Butterfly_BreatheInputs */

const en_key_helpful_butterfly_breathe = /** @type {(inputs: Key_Helpful_Butterfly_BreatheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goals`)
};

const de_key_helpful_butterfly_breathe = /** @type {(inputs: Key_Helpful_Butterfly_BreatheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziele`)
};

/**
* | output |
* | --- |
* | "Goals" |
*
* @param {Key_Helpful_Butterfly_BreatheInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const key_helpful_butterfly_breathe = /** @type {((inputs?: Key_Helpful_Butterfly_BreatheInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Key_Helpful_Butterfly_BreatheInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_key_helpful_butterfly_breathe(inputs)
	return de_key_helpful_butterfly_breathe(inputs)
});